import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

class AtheneumContacts extends Component {
  static propTypes = {
    projectStore: PropTypes.object
  }

  renderEmployees = list => {
    if (list.length < 1) return '-'
    return list.map((employee, index) => {
      const seperator = index + 1 >= list.length ? '' : ', '
      return employee.fullName + seperator
    })
  }

  init = () => {
    const { projectStore } = this.props
    return (
      <div>
        <span className='team-label'>
          Atheneum contacts:
          <div className='team-label__list'>
            {this.renderEmployees(projectStore.project.employees)}
          </div>
        </span>
      </div>
    )
  }

  render () {
    return <div className='project-team-wrapper'>{this.init()}</div>
  }
}

export default inject('projectStore')(observer(AtheneumContacts))
